
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import infoTitle from "@/components/info-title/info-title.vue";
import { calledMeasurementFee } from "@/api/api-basic-websocket";
import { sendPileOperation } from "@/api/api-basic";
import qrcode from "@/components/qrcode/qrcode.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-info-title": infoTitle,
    "pi-qrcode": qrcode
  }
})
export default class CollectionDataRateConfig extends Vue {
  @Prop({
    default: () => {
      return {};
    }
  })
  private search!: objAny;
  @Prop({
    default: () => {
      return {};
    }
  })
  private gunData!: objAny;
  @Prop({
    default: () => {
      return {};
    }
  })
  private tiows!: objAny;
  @Prop({ default: 0 }) private isOpen!: number;

  private formInline: objAny = {
    rateName: ""
  };
  private qrCord = "";
  private sendMsgText = "";
  private returnMsgText = "";
  // private loading = false;
  // private rateList: object = [];
  // private tableList: object[] = [];
  // private tableColumns: object[] = [
  //   {
  //     title: "电价类型",
  //     key: "pilePkId",
  //     minWidth: 130
  //   },
  //   {
  //     title: "桩电价(元/kWh)",
  //     key: "pilePkId",
  //     minWidth: 130
  //   },
  //   {
  //     title: "平台电价(元/kWh)",
  //     key: "pilePkId",
  //     minWidth: 130
  //   },
  //   {
  //     title: "桩服务费(元/kWh)",
  //     key: "pilePkId",
  //     minWidth: 130
  //   },
  //   {
  //     title: "平台电价(元/kWh)",
  //     key: "pilePkId",
  //     minWidth: 130
  //   },
  //   {
  //     title: "时间段",
  //     key: "pilePkId",
  //     minWidth: 130
  //   }
  // ];

  async getRateTemp() {
    const ret = await calledMeasurementFee({
      pilePkId: this.search.pilePkId,
      gunPkId: this.search.gunPkId,
      type: 2,
      content: ""
    });
    if (ret.status == this["$config"].apiStatus) {
      console.log("发送成功");
    }
  }
  async downQCode() {
    if (this.search.gunPkId != "") {
      const ret = await sendPileOperation({
        gunPkId: this.search.gunPkId,
        operationType: 1,
        serialNumber: this.gunData.sn,
        pilePkId: this.search.pilePkId,
        cmdCode: this.formInline.rateName
      });
      if (ret.status === this.$config.apiStatus) {
        this.$Message.success(i18n.t("dataConfig.issueSuccess"));
      }
    }
  }
  async send() {
    if (this.isOpen == 2 && this.search.gunPkId && this.search.gunPkId != "") {
      const ret = await calledMeasurementFee({
        pilePkId: this.search.pilePkId,
        type: 4,
        content: this.sendMsgText,
        gunPkId: this.search.gunPkId
      });
      if (ret.status == this["$config"].apiStatus) {
        console.log("发送成功");
      }
    }
  }
  public getQrcodeData(data: objAny) {
    this.formInline.rateName = data.qrCord;
    this.qrCord = data.qrCord + "";
  }
  public returnMsgTextData(str: string) {
    this.returnMsgText = str;
  }
}
